export default __webpack_public_path__ + "static/media/warning.0e7856e2.mp3";